"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentPage = exports.PageWrapper = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../../components/styles/theme"));
const BasePage_1 = require("./BasePage");
const TaskHeader_1 = require("../../components/task-header/TaskHeader");
const MaxWidthWrapper_1 = require("../../components/max-width/MaxWidthWrapper");
exports.PageWrapper = styled_1.default.div `
	// 90px (<TaskNavigator>) + 65px (Intercom bubble) will not overlap content
    margin: 0 auto 155px auto;
    font-family: ${theme_1.default.typography.fonts.base};
`;
const ContentPage = (props) => {
    const { children } = props, header = __rest(props, ["children"]);
    return React.createElement(BasePage_1.BasePage, { header: React.createElement(TaskHeader_1.Header, Object.assign({}, header)) },
        React.createElement(exports.PageWrapper, null,
            React.createElement(MaxWidthWrapper_1.MaxWidthWrapper, null, children)));
};
exports.ContentPage = ContentPage;
//# sourceMappingURL=ContentPage.js.map